import { AgrupadorV22 } from "../meta-v22";

// FIXME: Manejo de idiomas
export const AGRUPADORES: AgrupadorV22[] = [
    {
      nombre: "Transferencias", items: [
        {
          id: 12,
          nombre: "Transferencias",
          nickname: "TRA",
          descriptor: "Los estudiantes podrán usar independientemente su aprendizaje para:",
          icono: "",
          clase: ""
        },
      ], icono: "sports_score", clase: "metas-de-transferencia"
    },
    {
      nombre: "Compresiones y preguntas esenciales", items: [
        {
          id: 13,
          nombre: "Compresiones",
          nickname: "COM",
          descriptor: "Los estudiantes comprenderán que:",
          icono: "psychology",
          clase: ""
        },
        {
          id: 14,
          nombre: "Preguntas esenciales",
          nickname: "PRE",
          descriptor: "Los estudiantes seguirán considerando:",
          icono: "psychology_alt",
          clase: ""
        },
      ], icono: "settings", clase: "compresiones-y-preguntas-esenciales"
    },
    {
      nombre: "Conocimientos y habilidades", items: [{
        id: 16,
        nombre: "Conocimiento",
        nickname: "CON",
        descriptor: "Los estudiantes conocerán:",
        icono: "lightbulb",
        clase: ""
      },
      {
        id: 17,
        nombre: "Habilidades",
        nickname: "HAB",
        descriptor: "Los estudiantes serán capaces de:",
        icono: "star",
        clase: ""
      },
      ], icono: "handshake", clase: "conocimientos-y-habilidades"
    },
  ]
  